// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ModalWrapper_overlay__pQU6p","closeBack":"ModalWrapper_closeBack__sHJSM","window":"ModalWrapper_window__2bDBI","closeButton":"ModalWrapper_closeButton__xfANT"};